var currencySymbol = '£';
export var validKeys = [
    'Backspace',
    'Enter',
    'Delete',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
    'Tab',
];
export var firstDotPosition = function (num) {
    return num.indexOf('.');
};
export var adaptValueToFormat = function (num, decimals) {
    var firstDot = firstDotPosition(num);
    if (firstDot > -1) {
        var newNum = num.slice(0, firstDot + decimals + 1);
        return newNum;
    }
    else
        return num;
};
export var fixToDecimals = function (value, decimals) {
    return Number(value).toFixed(decimals);
};
export var containsDecimals = function (value) {
    var dotPos = firstDotPosition(value);
    return dotPos > -1 && dotPos < value.length;
};
export var format = function (value) {
    var valueFormatted = value
        .toString()
        .split('')
        .reverse()
        .join('')
        .match(/.{1,3}/g)
        .join(',')
        .split('')
        .reverse()
        .join('');
    return valueFormatted;
};
export var getIntPart = function (value) {
    var intPart = value.slice(0, firstDotPosition(value));
    if (Number(intPart) === 0)
        return '0';
    else
        return intPart;
};
export var getDecimalPart = function (value, decimals) {
    var dotPos = firstDotPosition(value);
    return value.slice(dotPos, dotPos + 1 + decimals);
};
export var getNumDecimalPlaces = function (value) {
    var dotPos = firstDotPosition(value);
    return value.slice(dotPos + 1).length;
};
export var formatWithDecimals = function (value, decimals) {
    var intValueFormatted = format(getIntPart(value));
    var decimalPart = getDecimalPart(value, decimals);
    return intValueFormatted + decimalPart;
};
export var getFinalValueWithFormat = function (value, decimals) {
    var newValueWithNoCommasOrCurrencySymbol = value
        .replace(/,/g, '')
        .replace(currencySymbol, '');
    if (firstDotPosition(newValueWithNoCommasOrCurrencySymbol) === -1) {
        var newValueWithDecimals = newValueWithNoCommasOrCurrencySymbol.concat('.', new Array(decimals).fill('0').join(''));
        var val = formatWithDecimals(newValueWithDecimals, decimals);
        return val;
    }
    return value;
};
export var appendMissingZeros = function (value, decimals) {
    if (value !== '') {
        var decimalPart = getDecimalPart(value, decimals);
        if (decimalPart.length < decimals + 1) {
            var intValueFormatted = format(getIntPart(value));
            decimalPart = decimalPart.padEnd(decimals + 1, '0');
            return intValueFormatted + decimalPart;
        }
    }
    return value;
};
export var validateCurrency = function (value, min, max) {
    if (value !== undefined && value !== null) {
        var numericValue = Number(value.toString().replace(/,/g, '').replace(currencySymbol, ''));
        if (min !== null && numericValue < min)
            return 'tooSmall';
        if (max !== null && numericValue > max)
            return 'tooBig';
        return undefined;
    }
    return 'empty';
};
export var getNumberOfCommas = function (value, pos) {
    if (!value)
        return 0;
    if (pos > 0) {
        return value.slice(0, pos).match(/,/g)
            ? value.slice(0, pos).match(/,/g).length
            : 0;
    }
    else
        return value.match(/,/g) ? value.match(/,/g).length : 0;
};
export var calculateCursorPosition = function (cursor, ev, prevValue, commasBefore, delKey) {
    if (delKey) {
        if (cursor === 0) {
            ev.target.selectionStart = cursor;
            ev.target.selectionEnd = cursor;
        }
        else {
            var newCommasBefore = getNumberOfCommas(ev.target.value, cursor);
            ev.target.selectionStart =
                commasBefore > newCommasBefore ? cursor - 1 : cursor;
            ev.target.selectionEnd =
                commasBefore > newCommasBefore ? cursor - 1 : cursor;
        }
    }
    else {
        if (cursor === 0) {
            ev.target.selectionStart = 1;
            ev.target.selectionEnd = 1;
        }
        else {
            var newCommasBefore = getNumberOfCommas(ev.target.value, cursor);
            if (ev.target.value.length > prevValue.length) {
                ev.target.selectionStart =
                    newCommasBefore > commasBefore ? cursor + 2 : cursor + 1;
                ev.target.selectionEnd =
                    newCommasBefore > commasBefore ? cursor + 2 : cursor + 1;
            }
            if (ev.target.value.length < prevValue.length) {
                if (newCommasBefore < commasBefore) {
                    ev.target.selectionStart = cursor - 2;
                    ev.target.selectionEnd = cursor - 2;
                }
                else {
                    ev.target.selectionStart =
                        ev.target.value[cursor - 2] === ',' ? cursor - 2 : cursor - 1;
                    ev.target.selectionEnd =
                        ev.target.value[cursor - 2] === ',' ? cursor - 2 : cursor - 1;
                }
            }
        }
    }
    return [ev.target.selectionStart, ev.target.selectionEnd];
};
//# sourceMappingURL=helpers.js.map